export default () => ({
    count: 0,
    open() {
        this.count += 1;
    },
    close() {
        this.count -= 1;
    },
});
